import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TabService } from '../../shared/tab.service';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [HttpClientModule, NgbDropdownModule, FormsModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private baseUrl = environment.apiBaseUrl;
  private apiversion = environment.apiversion;
  selectedLocation = '';
  filteredLocations: string[] = [];
  showSuggestions = false;
  userName: any = '';
  userImage = 'assets/images/profile-icon.png';

  locations = ['Dhananya Marketing Bhuj', 'Ahmedabad', 'Surat', 'Rajkot'];

  activeTab: string = 'primary';

  @Input()
  componentName: string = '';

  customerCode: any;

  constructor(
    private tabService: TabService,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.customerCode = localStorage.getItem('customerCode')?.toString();
    this.getUserProfile();
    this.tabService.activeTab$.subscribe((tab) => {
      this.activeTab = tab;
    });
  }

  getUserProfile() {
    let request = { userName: this.customerCode };
    const headers = new HttpHeaders({ 'skip-loader': 'true' });

    this.http
      .post(
        `${this.baseUrl}/userprofile`,
        request,
        { headers }
      )
      .subscribe({
        next: (response: any) => {
          if (response.success && response.result) {
            this.userName = response.result.name;
            if (response.result.name) {
              localStorage.setItem('fullName', response.result.name);
              localStorage.setItem('employeeName', response.result.name);
            }
          } else {
            console.error(
              'API Error:',
              response.errors?.[0]?.message || 'Unknown error'
            );
          }
        },
        error: (error: any) => {
          console.error('Request failed:', error);
        },
      });
  }

  setActiveTab(tab: string) {
    this.tabService.setActiveTab(tab);
  }

  isOrderWorkflowPage(): boolean {
    return this.componentName === 'Primary Order' ||
           this.componentName === 'Create Sales Order' ||
           this.componentName === 'Create Sales Invoice';
  }

  getOrderTypeLabel(): string {
    if (this.componentName === 'Create Sales Order') {
      return 'Sales Order';
    } else if (this.componentName === 'Create Sales Invoice') {
      return 'Sales Invoice';
    }
    return 'Primary Order';
  }

  onLocationInput() {
    let query = this.selectedLocation.toLowerCase();
    this.filteredLocations = this.locations.filter((loc) =>
      loc.toLowerCase().includes(query)
    );
  }

  selectLocation(loc: string) {
    this.selectedLocation = loc;
    this.filteredLocations = [];
    this.showSuggestions = false;
  }

  logout() {
    localStorage.removeItem('customerCode');
    localStorage.removeItem('authToken');
    this.router.navigate(['/login'], { replaceUrl: true }); // ✅ replaces history entry
    console.log('Logged out');
  }
}
